import React from 'react';
import { Flex } from '@withjoy/joykit';
import { usePublicShopCustomizeNowClickHandler } from '@apps/card/routes/PublicShop/routes/Gallery/usePublicShopCustomizeNowClickHandler';
import { MarcomAppNavBar } from '../../components/MarcomAppNavBar';
import { ShopRouter } from '@apps/card/routes/Dashboard/components/DesignsGallery/ShopRouter';
import { Redirect, Route, Switch } from '@react-router';
import { useCardsRouterContext } from '@apps/card/Card.routes';
import { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { useScrollToTopAfterNavigation } from '@apps/card/hooks/useScrollToTopAfterNavigation';
import { DynamicBannerContext, useDynamicBannerState } from '@apps/card/components/DynamicBanner/useDynamicBanner';
import { DynamicBanner } from '@apps/card/components/DynamicBanner/DynamicBanner';
import { useCatalogFreeShippingBanner } from '@apps/card/hooks/useFreeShippingBanner';
import { useIsPublicGallerySsr } from '@apps/card/routes/Dashboard/components/DesignsGallery/useIsPublicGallerySsr';

export const Gallery = () => {
  const { goToCustomizeDraftOrLogin } = usePublicShopCustomizeNowClickHandler();

  const { routes, getShopPath } = useCardsRouterContext();
  useScrollToTopAfterNavigation();

  // Server-rendered with the free-shipping banner in place (PRNT-5494), so it doesn't push the
  // gallery down once products load on the client. Off that path it appears once they do, as before.
  const isPublicGallerySsr = useIsPublicGallerySsr();
  const catalogFreeShippingBanner = useCatalogFreeShippingBanner();
  const dynamicBanner = useDynamicBannerState(isPublicGallerySsr ? catalogFreeShippingBanner : undefined);

  return (
    <DynamicBannerContext.Provider value={dynamicBanner}>
      <Flex
        flexDirection="column"
        height="100dvh"
        width="100dvw"
      >
        <DynamicBanner banner={dynamicBanner.banner} />
        <Flex
          flex={1}
          flexDirection="column"
          position="relative"
          overflow="auto"
        >
          <MarcomAppNavBar />
          <Switch>
            <Route
              path={routes.designsGallery.paths}
              render={({ match }) => {
                return (
                  <ShopRouter
                    match={match}
                    onCustomizeClickCardOverride={goToCustomizeDraftOrLogin}
                  />
                );
              }}
            />
            <Redirect to={getShopPath('wedding', StationeryTemplateCategoryEnum.saveTheDate)} />
          </Switch>
        </Flex>
      </Flex>
    </DynamicBannerContext.Provider>
  );
};
